import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { AuthSequence } from "../Sequences/AuthSequence";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { UserSettingsInterface } from "../../Entity/Entities/Settings/User/UserSettingsInterface";
import UserActions from "../../Action/Actions/UserActions";
import Decoder from "../../Token/Decoder";
import TokenActions from "../../Action/Actions/TokenActions";
import Token from "../../Token/Token";
import Auth from "../../Auth/Auth";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import UserSettingsFactory from "../../Entity/Factories/UserSettingsFactory";

export default function* checkToken(action: ActionInterface): any {
  try {
    const token: string = yield call(Token.get);
    const pathname: string = (window as any).location.pathname;

    // If we don't have a token, redirect user to sign in.
    if (!token) {
      if (action.hasOwnProperty("onSuccess") === true) {
        action.onSuccess.call(this, false);
      }

      // need this logic if user paste the url in new tab and after login we should redirect him to pasted url
      // https://casadesk.atlassian.net/browse/CASA-7334
      yield put({
        type: Constants.REDIRECTOR_ADD_PATHNAME,
        payload: {
          pathname: pathname
        }
      });

      if (pathname !== "/auth/signup") {
        return yield put({
          type: Constants.PAGE_SIGNOUT_START,
          payload: {
            shouldSaveRedirectorPath: true
          }
        });
      }
    }

    // Should decode token to check if it expired
    const jwtToken = Decoder.decode(token);

    // If token is expired, redirect user to sign in.
    if (jwtToken.isExpired === true) {
      if (action.hasOwnProperty("onSuccess") === true) {
        action.onSuccess.call(this, false);
      }

      if (pathname !== "/auth/signup") {
        return yield put({
          type: Constants.PAGE_SIGNOUT_START
        });
      }
    }

    // Get the fresh person data from backend.
    const res = yield call(Auth.getSession, token);

    const user: PersonInterface = PersonFactory.create(res);
    const settings: UserSettingsInterface = UserSettingsFactory.create(res.userSettings[0]);

    // Load the application.
    yield put(UserActions.auth(user, settings));

    yield put(TokenActions.update(token));
    yield put(TokenActions.successToken());

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, true);
    }

    yield AuthSequence();
  } catch (err) {
    const pathname: string = (window as any).location.pathname;
    
    yield put(TokenActions.failToken(err));

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, false);
    }

    if (pathname !== "/auth/signup") {
      return yield put({
        type: Constants.PAGE_SIGNOUT_START
      });
    }

    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchCheckToken() {
  yield takeEvery(Constants.TOKEN_CHECK, checkToken);
}
